<ng-template #spinner>
  <div class="content-box" [nbSpinner]="true"></div>
</ng-template>

<div *ngIf="(data$ | async) as data; else spinner">  
  <div class="content-box">
    <div class="content-box__information">
      <div class="content-box__information--title">{{ 'statistics.printing-time' | translate }}</div>
      <span class="content-box__information--description">{{ 'statistics.printing-time-description' | translate }}</span>
    </div>
  
    <div class="content-box__doughnuts">
      <div class="content-box__doughnuts--doughnut">
        <app-doughnut 
          [descriptionText]="totalPrintingTime(data.todayPrintingTime).toString() + ' min'"
          [colors]="printTimeColors"
          [chartData]="getPrintTimeChart(data.todayPrintingTime)"
        ></app-doughnut>
  
        <span>{{ 'common.today' | translate | titlecase }}</span>
      </div>
  
      <div class="content-box__doughnuts--doughnut">
        <app-doughnut 
          [descriptionText]="totalPrintingTime(data.weekPrintingTime).toString() + ' min'"
          [colors]="printTimeColors"
          [chartData]="getPrintTimeChart(data.weekPrintingTime)"
        ></app-doughnut>
  
        <span>7 {{ 'common.days' | translate }}</span>
      </div>
    </div>
  </div>  

  <div class="content-box">
    <div class="content-box__information">
      <div class="content-box__information--title">{{ 'statistics.materials-used' | translate }}</div>
      <span class="content-box__information--description">{{ 'statistics.materials-used-description' | translate }}</span>
    </div>
  
    <div class="content-box__doughnuts">
      <div class="content-box__doughnuts--doughnut">
        <app-doughnut
          [descriptionText]="data.todayUsedMaterials.totalMaterialUsage | convertTo: fromUnit : toUnit"
          [colors]="materialColors"
          [chartData]="getMaterialUsage(data.todayUsedMaterials)"
        ></app-doughnut>
  
        <span>{{ 'common.today' | translate | titlecase }}</span>
      </div>
  
      <div class="content-box__doughnuts--doughnut">
        <app-doughnut 
          [descriptionText]="data.weekUsedMaterials.totalMaterialUsage | convertTo: fromUnit : toUnit"
          [colors]="materialColors"
          [chartData]="getMaterialUsage(data.weekUsedMaterials)"
        ></app-doughnut>
  
        <span>7 {{ 'common.days' | translate }}</span>
      </div>
    </div>
  </div>
</div>
